// extracted by mini-css-extract-plugin
export default {"tooltip":"ToolTip_tooltip__fsxWD","show":"ToolTip_show__SEm41"};